export default __webpack_public_path__ + "static/media/Tiempo_Seco.22e1bacc.svg";